module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "label-width": "160px"
    }
  }, [_vm._l((_vm.row.member_list), function(member, index) {
    return _c('div', [_c('el-divider', [_vm._v("人员信息" + _vm._s(index + 1))]), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": '人员' + (index + 1)
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (member.name),
        expression: "member.name"
      }]
    }, [_vm._v(_vm._s(member.name + '(' + member.num + ')'))])])], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.row.shenbaotype.indexOf('caipandengjiwudao') > -1) ? _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "裁判等级申报(舞蹈)：",
        "prop": "caipan"
      }
    }, [_c('el-radio-group', {
      model: {
        value: (member.caipanshenbaowudao),
        callback: function($$v) {
          _vm.$set(member, "caipanshenbaowudao", $$v)
        },
        expression: "member.caipanshenbaowudao"
      }
    }, _vm._l((member.caipandengjiwudaooptions), function(item) {
      return _c('el-radio', {
        attrs: {
          "label": item
        }
      }, [_vm._v(_vm._s(item))])
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "form-label-desc"
    }, [_vm._v(_vm._s('现有等级 ' + (member.caipandengjiwudao ? member.caipandengjiwudao : '无')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.row.shenbaotype.indexOf('caipandengjijiqiao') > -1) ? _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "裁判等级申报(技巧)：",
        "prop": "caipan"
      }
    }, [_c('el-radio-group', {
      model: {
        value: (member.caipanshenbaojiqiao),
        callback: function($$v) {
          _vm.$set(member, "caipanshenbaojiqiao", $$v)
        },
        expression: "member.caipanshenbaojiqiao"
      }
    }, _vm._l((member.caipandengjijiqiaooptions), function(item) {
      return _c('el-radio', {
        attrs: {
          "label": item
        }
      }, [_vm._v(_vm._s(item))])
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "form-label-desc"
    }, [_vm._v(_vm._s('现有等级 ' + (member.caipandengjijiqiao ? member.caipandengjijiqiao : '无')))])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [(_vm.row.shenbaotype.indexOf('jiaoliandengjiwudao') > -1) ? _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "教练等级申报(舞蹈)：",
        "prop": "jiaolian"
      }
    }, [_c('el-radio-group', {
      model: {
        value: (member.jiaolianshenbaowudao),
        callback: function($$v) {
          _vm.$set(member, "jiaolianshenbaowudao", $$v)
        },
        expression: "member.jiaolianshenbaowudao"
      }
    }, _vm._l((member.jiaoliandengjiwudaooptions), function(item) {
      return _c('el-radio', {
        attrs: {
          "label": item
        }
      }, [_vm._v(_vm._s(item))])
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "form-label-desc"
    }, [_vm._v(_vm._s('现有等级 ' + (member.jiaoliandengjiwudao ? member.jiaoliandengjiwudao : '无')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.row.shenbaotype.indexOf('jiaoliandengjijiqiaooptions') > -1) ? _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "教练等级申报(技巧)：",
        "prop": "jiaolian"
      }
    }, [_c('el-radio-group', {
      model: {
        value: (member.jiaolianshenbaojiqiao),
        callback: function($$v) {
          _vm.$set(member, "jiaolianshenbaojiqiao", $$v)
        },
        expression: "member.jiaolianshenbaojiqiao"
      }
    }, _vm._l((member.jiaoliandengjijiqiaooptions), function(item) {
      return _c('el-radio', {
        attrs: {
          "label": item
        }
      }, [_vm._v(_vm._s(item))])
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "form-label-desc"
    }, [_vm._v(_vm._s('现有等级 ' + (member.jiaoliandengjijiqiao ? member.jiaoliandengjijiqiao : '无')))])], 1)], 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7488bde5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiApplyFormStep3.vue
// module id = 1474
// module chunks = 0